import { Seedling, Spade } from 'src/components/atoms/Icons'
import { FlowStep } from 'src/components/organisms/FlowStepper'

import { GetAccountAndPlanterRegistrationQuery } from 'src/config/generated/graphql'
import {
  createPlanterRegistrationPath,
  createProjectPath,
  selectProjectPath,
  viewAccountPlanterRegistrationPath,
  viewProjectDetailPath
} from 'src/config/paths'
import { ArrayElement } from 'src/types/common'

import { GettingStartedGuidesProps } from './GettingStartedGuides'

type PantingSteps = 'experience' | 'project' | 'request'

export const gettingStartedLinks: GettingStartedGuidesProps['links'] = [
  {
    text: 'Requirements to be a planter with Trees That Count',
    href: 'https://help.treesthatcount.co.nz/en/articles/9560670-requirements-to-be-a-planter-with-trees-that-count'
  },
  {
    text: 'Requesting native trees for my planting project',
    href: 'https://help.treesthatcount.co.nz/en/articles/8514952-requesting-native-trees-for-my-planting-'
  },
  {
    text: 'National guides for planting native trees',
    href: 'https://help.treesthatcount.co.nz/en/articles/8366659-national-guides-for-planting-native-trees'
  }
]

type GetStepsParams = {
  defaultProject?: ArrayElement<
    NonNullable<
      NonNullable<
        GetAccountAndPlanterRegistrationQuery['Account_by_pk']
      >['Planter']
    >['Projects']
  > | null
  hasApprovedRequest: boolean
  hasPastProjects: boolean
  hasValidPlanterExperience: boolean
  projectCount: number
}

export const getSteps = ({
  defaultProject,
  hasApprovedRequest,
  hasPastProjects,
  hasValidPlanterExperience,
  projectCount
}: GetStepsParams): Array<FlowStep<PantingSteps>> => {
  return [
    {
      label: 'Add planting experience',
      value: 'experience',
      href: hasValidPlanterExperience
        ? viewAccountPlanterRegistrationPath
        : createPlanterRegistrationPath,
      icon: Seedling,
      state: () => {
        if (hasValidPlanterExperience || hasApprovedRequest) {
          return 'complete'
        }
        return 'default'
      }
    },
    {
      label: 'Add planting project',
      value: 'project',
      href: !defaultProject
        ? createProjectPath()
        : viewProjectDetailPath({
            routeParams: {
              projectId: defaultProject?.Id
            }
          }),
      icon: Spade,
      state: () => {
        if (!hasValidPlanterExperience && !hasApprovedRequest) return 'disabled'
        if (projectCount > 0) {
          return 'complete'
        }
        return 'default'
      }
    },
    {
      label: 'Request trees',
      value: 'request',
      href: selectProjectPath,
      icon: Spade,
      state: () => {
        if (
          (!hasValidPlanterExperience && !hasApprovedRequest) ||
          projectCount === 0
        )
          return 'disabled'
        if (hasPastProjects) {
          return 'complete'
        }
        return 'default'
      }
    }
  ]
}
